import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';
import { HorizontalRule } from '../HorizontalRule';

export const StyledDirectDebitInstructionOverlay = styled('div')``;

const StyledHeadingDefault = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_15_bold_lh_24_desktop_17};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(0, 0)};
        &:not(:first-of-type) {
            margin-top: ${theme.tggSpacing(rem(4), 10)};
        }
        color: ${theme.palette.common.blue};
        text-transform: initial;
	`}
`;
StyledHeadingDefault.defaultProps = {
    variant: 'h4',
    as: 'h2',
};
export const StyledHeading = StyledHeadingDefault;

export const StyledStrong = styled('strong')`
    ${({ theme }: { theme: Theme }) => `
        display: block;
        margin-bottom: ${theme.tggSpacing(rem(0.5), 1.25)};
        font-family: thegymgroupsans-Headline;
        font-weight: normal;
	`}
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(1), 0], [2.5, 0])};
	`}
`;
